import { Controller } from '@hotwired/stimulus';
import { getContentType, primeForPostLogin } from 'lib/helpers';
import { getResourceType } from 'lib/resource-show-helpers';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import {
  FAVORITE_CLICK,
  LOGIN_TRIGGERED,
} from 'components/analytics/conversions/constants/actions';

export default class ResourceFavoriteController extends Controller {
  sendAnalytics(event) {
    sendTrackingEvent({
      element: event.currentTarget,
      data: {
        action: FAVORITE_CLICK,
        label: getResourceType(),
        content_type: `Content-${getContentType()}`,
      },
    });
  }

  favoriteAfterLogin = () => {
    const resourceControllerElem = document.querySelector('[data-controller*="resource-show-main"]');
    const { resourceId } = resourceControllerElem.dataset;

    // Sends Trigger events to Google Analytics
    sendTrackingEvent({
      data: {
        category: 'Trigger-Favorite',
        action: LOGIN_TRIGGERED,
      },
    });

    primeForPostLogin('favorite_after_login', resourceId);
  }
}
